// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgPeople24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9 2.25C6.37665 2.25 4.25 4.37665 4.25 7C4.25 9.62335 6.37665 11.75 9 11.75C11.6234 11.75 13.75 9.62335 13.75 7C13.75 4.37665 11.6234 2.25 9 2.25ZM13 14.25C15.6234 14.25 17.75 16.3766 17.75 19V21C17.75 21.4142 17.4142 21.75 17 21.75H1C0.585786 21.75 0.25 21.4142 0.25 21V19C0.25 16.3766 2.37665 14.25 5 14.25H13ZM13.1844 15.7551L13 15.75H5C3.20507 15.75 1.75 17.2051 1.75 19V20.25H16.25V19C16.25 17.267 14.8935 15.8508 13.1844 15.7551ZM12.25 7C12.25 5.20507 10.7949 3.75 9 3.75C7.20507 3.75 5.75 5.20507 5.75 7C5.75 8.79493 7.20507 10.25 9 10.25C10.7949 10.25 12.25 8.79493 12.25 7ZM19.2738 14.9425C19.3774 14.5414 19.7864 14.3003 20.1875 14.4038C22.2834 14.945 23.7484 16.8348 23.75 19V21C23.75 21.4142 23.4142 21.75 23 21.75C22.5858 21.75 22.25 21.4142 22.25 21V19.0006C22.2489 17.5195 21.2466 16.2265 19.8125 15.8562C19.4114 15.7526 19.1703 15.3436 19.2738 14.9425ZM16.186 2.40344C15.7848 2.3007 15.3762 2.5427 15.2734 2.94397C15.1707 3.34524 15.4127 3.75382 15.814 3.85656C17.252 4.22476 18.2578 5.52056 18.2578 7.005C18.2578 8.48944 17.252 9.78524 15.814 10.1534C15.4127 10.2562 15.1707 10.6648 15.2734 11.066C15.3762 11.4673 15.7848 11.7093 16.186 11.6066C18.2878 11.0684 19.7578 9.17457 19.7578 7.005C19.7578 4.83543 18.2878 2.94158 16.186 2.40344Z"
				/>
			</Svg>
		);
	}
);
SvgPeople24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgPeople24;
